(() => {
  const SEL = {
    modal: '[data-store-locator-modal]', panel: '[data-store-locator-panel]', open: '[data-store-locator-open]',
    close: '[data-store-locator-close]', initial: '[data-store-view="initial"]', blocked: '[data-store-view="blocked"]',
    results: '[data-store-view="results"]', favorite: '[data-store-view="favorite"]', useLocation: '[data-use-location]',
    postalForm: '[data-postal-form]', postal: '[data-postal-input]', stateList: '[data-state-list]', resultsList: '[data-store-results]',
    resultsTitle: '[data-results-title]', select: '[data-select-store]', mapAll: '[data-map-all]', change: '[data-change-store]',
    mapStore: '[data-map-store]', favoriteContent: '[data-favorite-content]', error: '[data-store-error]', headerLabel: '[data-store-header-label]'
  };

  class StoreLocatorModal {
    constructor(root) {
      this.root = root;
      this.modal = root.querySelector(SEL.modal);
      this.selectedStore = null;
      this.results = [];
      this.searchContext = null;
      this.lastResultsState = null;
      this.bind();
      this.renderStates();
      this.loadFavorite();
    }

    bind() {
      document.querySelectorAll(SEL.open).forEach((button) => button.addEventListener('click', () => this.open()));
      this.root.querySelectorAll(SEL.close).forEach((button) => button.addEventListener('click', () => this.close()));
      this.modal?.addEventListener('click', (event) => { if (event.target === this.modal) this.close(); });
      this.root.querySelector(SEL.useLocation)?.addEventListener('click', () => this.useLocation());
      this.root.querySelector(SEL.postalForm)?.addEventListener('submit', (event) => this.searchPostal(event));
      this.root.querySelector(SEL.resultsList)?.addEventListener('click', (event) => this.onResultsClick(event));
      this.root.querySelector(SEL.select)?.addEventListener('click', () => this.confirmSelected());
      this.root.querySelector(SEL.mapAll)?.addEventListener('click', () => this.openMapForContext());
      this.root.querySelector(SEL.change)?.addEventListener('click', () => this.changeStore());
      this.root.querySelector(SEL.mapStore)?.addEventListener('click', () => this.openSelectedStoreMap());
      document.addEventListener('keydown', (event) => { if (event.key === 'Escape' && this.modal?.dataset.open === 'true') this.close(); });
    }

    open() {
      if (!this.modal) return;
      this.modal.dataset.open = 'true';
      this.modal.removeAttribute('hidden');
      document.documentElement.classList.add('store-locator-lock');
      if (this.favoriteResponse) this.showFavorite(this.favoriteResponse);
      else this.show('initial');
    }

    close() {
      if (!this.modal) return;
      this.modal.dataset.open = 'false';
      this.modal.setAttribute('hidden', '');
      document.documentElement.classList.remove('store-locator-lock');
    }

    show(name) {
      this.root.querySelectorAll('[data-store-view]').forEach((view) => {
        view.hidden = view.dataset.storeView !== name;
      });
      this.clearError();
    }

    clearError() {
      const error = this.root.querySelector(SEL.error);
      if (error) { error.textContent = ''; error.hidden = true; }
    }

    setError(message) {
      const error = this.root.querySelector(SEL.error);
      if (error) { error.textContent = message; error.hidden = false; }
    }

    renderStates() {
      const container = this.root.querySelector(SEL.stateList);
      if (!container) return;
      container.innerHTML = window.ShasaStoreLocator.uniqueStates()
        .map(({ code, label }) => `<button type="button" class="store-locator__state" data-state-code="${code}">${label}</button>`)
        .join('');
      container.addEventListener('click', (event) => {
        const button = event.target.closest('[data-state-code]');
        if (!button) return;
        this.searchState(button.dataset.stateCode);
      });
    }

    async loadFavorite() {
      const config = window.ShasaStoreLocatorConfig || {};
      if (!config.customerId) return;
      const response = await window.ShasaStoreLocator.getFavoriteStore();
      if (!response?.data?.store) return;
      this.favoriteResponse = response;
      this.updateHeader(response.data.store);
    }

    updateHeader(store) {
      const label = document.querySelector(SEL.headerLabel);
      if (!label || !store) return;
      const name = String(store.name || '').replace(/^Shasa\s+/i, '').replace(/^.*?,\s*/, '');
      label.textContent = name || 'Tu tienda';
      label.closest('[data-store-locator-open]')?.classList.add('has-store');
    }

    async useLocation() {
      try {
        const coords = await window.ShasaStoreLocator.requestUserLocation();
        this.searchContext = { mode: 'location', lat: coords.lat, lng: coords.lng };
        this.renderResults(window.ShasaStoreLocator.storesNear(coords).slice(0, 3), '3 tiendas cerca de ti');
      } catch (error) {
        if (error?.code === 1) this.show('blocked');
        else this.setError('No pudimos obtener tu ubicación. Busca por código postal o estado.');
      }
    }

    async searchPostal(event) {
      event?.preventDefault();

      const form = event?.currentTarget;
      const input = form?.querySelector(SEL.postal);
      const postalCode = input?.value?.trim();

      if (!postalCode) return;

      try {
        const coords = await window.ShasaStoreLocator.geocodePostalCode(postalCode);

        this.searchContext = {
          mode: 'postal',
          postal_code: coords.postalCode,
          lat: coords.lat,
          lng: coords.lng
        };

        const stores = window.ShasaStoreLocator
          .storesNear(coords)
          .slice(0, 3);

        this.renderResults(
          stores,
          `${stores.length} tienda${stores.length === 1 ? '' : 's'} cerca de ${coords.postalCode}`
        );
      } catch (error) {
        console.error('[StoreLocator] Postal search failed:', error);

        this.setError(
          'No encontramos ese código postal. Verifica los 5 dígitos e inténtalo de nuevo.'
        );
      }
    }

    searchState(stateCode) {
      const stores = window.ShasaStoreLocator.storesByState(stateCode);
      this.searchContext = { mode: 'state', state: stateCode };
      const label = window.ShasaStoreLocator.STATE_LABELS[stateCode] || stateCode;
      this.renderResults(stores, `${stores.length} tienda${stores.length === 1 ? '' : 's'} en ${label}`);
    }

    renderResults(stores, title) {
      this.results = stores;
      this.selectedStore = null;
      this.lastResultsState = { stores, title, context: { ...this.searchContext } };
      this.show('results');
      const titleEl = this.root.querySelector(SEL.resultsTitle);
      if (titleEl) titleEl.textContent = title;
      const list = this.root.querySelector(SEL.resultsList);
      if (list) {
        list.innerHTML = stores.length ? stores.map((store) => this.storeCard(store)).join('') : '<p class="store-locator__empty">No encontramos tiendas para esta búsqueda.</p>';
      }
      const selectButton = this.root.querySelector(SEL.select);
      if (selectButton) selectButton.disabled = true;
    }

    storeCard(store) {
      const distance = Number.isFinite(store.distanceKm) ? `<span>${store.distanceKm.toFixed(1)} km</span>` : '';
      const address = [store.address1, store.municipality, store.state].filter(Boolean).join(', ');
      return `<button type="button" class="store-locator__result" data-store-code="${store.storeCode}">
        <span class="store-locator__result-title"><strong>${store.displayName}</strong>${distance}</span>
        <span class="store-locator__result-address">${address}</span>
        <span class="store-locator__result-status">Horario disponible al seleccionar la tienda</span>
      </button>`;
    }

    onResultsClick(event) {
      const card = event.target.closest('[data-store-code]');
      if (!card) return;
      this.root.querySelectorAll('[data-store-code]').forEach((node) => node.classList.remove('is-selected'));
      card.classList.add('is-selected');
      this.selectedStore = this.results.find((store) => store.storeCode === card.dataset.storeCode) || null;
      const selectButton = this.root.querySelector(SEL.select);
      if (selectButton) selectButton.disabled = !this.selectedStore;
    }

    async confirmSelected() {
      if (!this.selectedStore) return;
      const button = this.root.querySelector(SEL.select);
      if (button) button.disabled = true;
      try {
        const response = await window.ShasaStoreLocator.saveFavoriteStore(this.selectedStore.storeCode);
        this.favoriteResponse = response;
        this.showFavorite(response);
        this.updateHeader(response.data?.store || { name: this.selectedStore.displayName });
      } catch (error) {
        this.setError('No pudimos guardar tu tienda. Inténtalo nuevamente.');
        if (button) button.disabled = false;
      }
    }

    showFavorite(response) {
      const data = response?.data || {};
      const store = data.store || {};
      this.show('favorite');
      const content = this.root.querySelector(SEL.favoriteContent);
      if (!content) return;
      const address = store.address || {};
      content.innerHTML = `<div class="store-locator__favorite-title"><strong>${store.name || 'Tu tienda Shasa'}</strong><span>TU TIENDA</span></div>
        <p>${[address.address1, address.municipality, address.city].filter(Boolean).join(', ')}</p>
        ${this.scheduleMarkup(store.schedule_days)}
        <hr>
        <p class="store-locator__eyebrow">QUÉ HABILITA ESTA TIENDA</p>
        <ul class="store-locator__benefits"><li>Recoge gratis tu pedido aquí</li><li>Consulta disponibilidad para recoger en tienda</li><li>Cambios y devoluciones en mostrador</li></ul>`;
      this.favoriteStoreCode = data.store_code || this.selectedStore?.storeCode;
    }

    scheduleMarkup(days) {
      if (!Array.isArray(days) || !days.length) return '<p class="store-locator__result-status">Consulta el horario de la tienda antes de visitarla.</p>';
      const today = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'][new Date().getDay()];
      const item = days.find((day) => day.day === today) || days[0];
      return item ? `<p class="store-locator__result-status">Abierto ${item.open_time}–${item.close_time}</p>` : '';
    }

    changeStore() {
      if (this.lastResultsState) {
        this.searchContext = this.lastResultsState.context;
        this.renderResults(this.lastResultsState.stores, this.lastResultsState.title);
      } else {
        this.show('initial');
      }
    }

    openMapForContext() {
      location.href = window.ShasaStoreLocator.mapUrl(this.searchContext || {});
    }

    openSelectedStoreMap() {
      const storeCode = this.favoriteStoreCode || this.selectedStore?.storeCode;
      if (storeCode) location.href = window.ShasaStoreLocator.mapUrl({ store: storeCode });
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    const root = document.querySelector('[data-store-locator-root]');
    if (root && window.ShasaStoreLocator) window.shasaStoreLocatorModal = new StoreLocatorModal(root);
  });
})();
